// src/hooks/audience/useAudienceDomains.js
import { useCallback, useState } from "react";
import Api from "../../utils/Api";
import { API_ROUTE_AUDIENCE_CLASSIFICATION_DOMAINS } from "../../routes";

export function useAudienceDomains() {
  const [domains, setDomains] = useState([]);
  const [domainLoading, setDomainLoading] = useState(false);
  const [domainError, setDomainError] = useState("");

  const fetchDomains = useCallback(async (mappingStatus, domainName) => {
    setDomainLoading(true);
    setDomainError("");
    try {
      const resp = await Api.post(API_ROUTE_AUDIENCE_CLASSIFICATION_DOMAINS, {
        mappingStatus,
        domainName: domainName?.trim() || null,
        take: 500,
      });
      setDomains(Array.isArray(resp.data) ? resp.data : []);
    } catch (err) {
      setDomainError(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to load domains.",
      );
    } finally {
      setDomainLoading(false);
    }
  }, []);

  return {
    domains,
    domainLoading,
    domainError,
    setDomainError,
    fetchDomains,
  };
}
